/*
 * Read-only view: the redirect URIs as one bordered group so the list reads as a
 * single field-array block, clearly distinct from the neighbouring single-value fields.
 */
.readOnlyBox {
	display: grid;
	gap: var(--padding-base-y);
	padding: var(--padding-base-y);
	border: 1px solid var(--input-border);
	border-radius: var(--input-border-radius);
}
